var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFunction = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.992 4.708A2.25 2.25 0 0 1 10.47 3.11l.924.132a.75.75 0 0 0 .212-1.484l-.924-.133a3.75 3.75 0 0 0-4.13 2.663L5.979 6.25H4a.75.75 0 0 0 0 1.5h1.542L3.78 13.79a.75.75 0 1 0 1.44.42l1.884-6.46H10a.75.75 0 0 0 0-1.5H7.542l.45-1.542z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFunction);
export default ForwardRef;